<section class="rcx-table">
  <div class="row">
    <div class="col-lg-12">
      <div class="card btr">
        <div class="card-content">
          <div class="card-body table-responsive">
            <div class="row d-flex justify-content-between align-items-center">
              <div class="col-lg-auto">
                <h5 class="card-title m-0">
                  <i class="ri-account-pin-circle-line me-1 text-primary"></i>Accounts
                </h5>
              </div>
              <div class="col-sm-12 col-md-3 col-lg-auto">
                <div class="input-group">
                  <span class="input-group-text bg-primary" id="search" ngbTooltip="Search accounts by name."
                    placement="top" container="body">
                    <i class="bx bx-search-alt"></i>
                  </span>
                  <input type="text" class="form-control border-start-0" id="search" placeholder="Search..."
                    autocomplete="off" [(ngModel)]="searchKeyword">
                </div>
              </div>
              <div class="col-sm-12 col-md-3 col-lg-auto ps-1">
                <div class="input-group">
                  <span class="input-group-text bg-primary"><i class='bx bxs-layer'></i></span>
                  <ng-select class="rcx-ng-select ng-nav" bindLabel="name" placeholder="Select type" [(ngModel)]="type"
                    id="filter" [clearable]="true" [searchable]="false">
                    <ng-option *ngFor="let type of types" [value]="type">{{type}}</ng-option>
                  </ng-select>
                </div>
              </div>
              <div class="col-sm-12 col-md-3 col-lg-2 me-auto ps-1">
                <div class="input-group">
                  <button type="button" ngbTooltip="Fetch Records." placement="top" container="body"
                    class=" btn btn-secondary btn-sm " (click)="getAccountSelection()" style="height: 35px;">
                    <i class="bx bx-search-alt-2 ri-lg align-middle me-0"></i>
                  </button>
                </div>
              </div>
              <div class="col-sm-12 col-md-auto ms-auto">
                <button type="button" class="btn btn-secondary" (click)="upsertAccount()"
                  [ngClass]="{'not-allowed':!privilege.canEdit}"
                  [ngbTooltip]="!privilege.canEdit ? 'You need permissions for this action. Required permission(s): setup.account.edit' : ''">
                  <i class="bx bx-plus"></i> Add Account
                </button>
              </div>
            </div>
            <table class="table" id="table">
              <thead id="table-thead">
                <tr class="bg-light">
                  <th scope="col" width="70">#</th>
                  <th scope="col" width="150">Name</th>
                  <th scope="col" width="150">Type</th>
                  <th scope="col" width="150">Nature</th>
                  <th scope="col" width="150" class="text-center">Opening Balance</th>
                  <th scope="col" width="150" class="text-center">Mandatory</th>
                  <th scope="col" width="150" class="text-center">Actions</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let account of tableData.content| search : 'name' : searchKeyword; let i=index">
                  <td>{{i+1}}.</td>
                  <td>{{account.name}}</td>
                  <td>{{account.type}}</td>
                  <td>{{account.nature}}</td>
                  <td class="text-center">{{account.balance}}</td>
                  <td class="text-center">
                    <span 
                      class="badge rounded-pill" 
                      [ngClass]="account.mandatory ? 'bg-success' : 'bg-danger'">
                      {{ account.mandatory ? 'Yes' : 'No' }}
                    </span>
                  </td>                  
                  <td class="actions">
                    <div class="form-check form-switch">
                      <input class="form-check-input" type="checkbox" [id]="i" [checked]="account.disabled"
                        [ngClass]="{'no-event':account?.isDeleteInProgress,'not-allowed':!privilege.canEdit}"
                        [ngbTooltip]="!privilege.canEdit ? 'You need permissions for this action. Required permission(s): finance.account.edit' :account.disabled ? 'Mark ' + account.name + ' as enabled.' : 'Mark ' + account.name + ' as disabled.'"
                        placement="top" container="body" [(ngModel)]="account.disabled"
                        (change)="toggleAccountStatus(account)">
                      <label class="form-check-label" [for]="i"></label>
                    </div>
                    <i class="bx bx-edit alert-primary"
                      [ngClass]="{'no-event':account?.isDeleteInProgress,'not-allowed':!privilege.canEdit}"
                      [ngbTooltip]="!privilege.canEdit ? 'You need permissions for this action. Required permission(s): finance.account.edit' : 'Update Account'"
                      (click)="upsertAccount(account)"></i>
                    <i *ngIf="!account?.isDeleteInProgress" class="bx bx-trash alert-secondary"
                      [ngClass]="{'not-allowed':!privilege.canDelete}"
                      [ngbTooltip]="!privilege.canDelete ? 'You need permissions for this action. Required permission(s): finance.account.delete' : 'Delete Account'"
                      (click)="deleteAccount(account,i)"></i>
                    <div *ngIf="account?.isDeleteInProgress" role="status"
                      class="spinner-border spinner-border-sm text-danger">
                      <span class="visually-hidden">Loading...</span>
                    </div>
                  </td>
                </tr>
                <tr class="no-data">
                  <ng-container *ngIf="isLoading; else noDataTemplate">
                    <td colspan="7">Fetching data, please wait...</td>
                  </ng-container>
                  <ng-template #noDataTemplate>
                    <ng-container *ngIf="tableData.content && tableData.content.length < 1; else noSearchResults">
                      <td colspan="7">No accounts were found.</td>
                    </ng-container>
                    <ng-template #noSearchResults>
                      <td colspan="7" *ngIf="searchKeyword && (tableData.content | search : 'name' : searchKeyword).length == 0">
                        No accounts were found for the search results.
                      </td>
                    </ng-template>
                  </ng-template>
                </tr>
              </tbody>
            </table>
            <div class="row justify-content-between align-items-center pt-3">
              <div class="col-lg-auto">
                <div class="pagination-entries" id="tickets-table_length">
                  <label class="d-flex align-items-center m-0">
                    <span>Items per page</span>
                    <select name="tickets-table_length" aria-controls="tickets-table"
                      [(ngModel)]="tableData.size" (change)="loadTableData(null)"
                      class="custom-select custom-select-sm form-control form-control-sm mx-2">
                      <option *ngFor="let page of pageSizes" [value]="page">{{page}}</option>
                    </select>
                  </label>
                </div>                
              </div>
              <div *ngIf="tableData?.content?.length>0" class="col-lg-auto">
                <ngb-pagination [collectionSize]="tableData.totalElements" [(page)]="tableData.number"
                [pageSize]="tableData.size" (pageChange)="onPageChange($event)">
              </ngb-pagination>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>